export default __webpack_public_path__ + "static/media/BITE_ETH.e5f1ea3b.svg";